import { useContext } from "react";
import { NotificationContext, notificationContext } from "./notificationContext";


export const useNotification = (): NotificationContext => {
  return useContext(notificationContext);
}